module.exports = __webpack_public_path__ + "static/media/processing.4f1d68c7.png";